import { getAiPerformance } from '@/services/dashboard-service/dashboard.service';
import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import { ReactQueryKeys } from '@/utils/react-query-keys';
import { useQuery } from '@tanstack/react-query';

export function useAiPerformance(params: DashboardFilters, isCompanyAdmin?: boolean) {
  const {
    data: aiPerformanceData,
    error,
    isPending,
  } = useQuery({
    queryKey: ReactQueryKeys.AI_PERFORMANCE(params),
    queryFn: () => getAiPerformance(params),
    enabled: isCompanyAdmin || !!params.company_name,
  });

  return { aiPerformanceData, error, isPending };
}
